var _rect, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#34495e",
    width: 1200,
    height: 600
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#ecf0f1",
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: "bold",
    textAnchor: "middle",
    x: 600,
    y: 280
  }, "Gallery Banner")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#bdc3c7",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    textAnchor: "middle",
    x: 600,
    y: 340
  }, "Replace with actual image")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryBanner);
export default __webpack_public_path__ + "static/media/gallery-banner.1317abd42654e94924b7bc3460219bd7.svg";
export { ForwardRef as ReactComponent };